export interface HistoryResourceRef {
  historyResource: number;
}

/** Session-only immutable values; bounded retention never drops source bytes. */
export class HistoryMediaPool {
  private readonly byValue = new Map<string, number>();
  private readonly byId = new Map<number, string>();
  private sequence = 0;
  private characters = 0;

  constructor(private readonly characterLimit = 32 * 1024 * 1024) {}

  get stats() {
    return { count: this.byId.size, characters: this.characters };
  }

  store(source: string): string | HistoryResourceRef {
    if (source.length < 256 || !/^data:(?:image|audio)\//.test(source))
      return source;
    let id = this.byValue.get(source);
    if (id === undefined) {
      if (this.characters + source.length > this.characterLimit) return source;
      id = ++this.sequence;
      this.byValue.set(source, id);
      this.byId.set(id, source);
      this.characters += source.length;
    }
    return { historyResource: id };
  }

  restore(source: string | HistoryResourceRef): string {
    if (typeof source === "string") return source;
    const value = this.byId.get(source?.historyResource);
    if (value === undefined)
      throw new Error("Ресурс истории больше недоступен.");
    return value;
  }

  clear() {
    this.byValue.clear();
    this.byId.clear();
    this.characters = 0;
    // Do not reuse IDs: a stale snapshot must never resolve to another document.
  }
}
